import RightArrow from 'static/right-arrow.svg'

export default {
  rightArrow: RightArrow,
}